import clsx from 'clsx';
import { useState, type DetailedHTMLProps, type InputHTMLAttributes } from 'react';
import { BiHide, BiShow } from 'react-icons/bi';

import s from './inputs.module.scss';

export const PasswordInput = ({
  label,
  error,
  mandatory,
  className,
  type,
  ...props
}: {
  label: string;
  error?: string;
  mandatory?: boolean;
} & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>) => {
  const [show, setShow] = useState(false);

  return (
    <label className={clsx(s.InputRoot, className)}>
      <div className={s.Label}>
        <span>{label}</span>
        {mandatory && <span>*</span>}
      </div>
      <div className={clsx(s.InputWrapper, s.PasswordInput, error && s.error)}>
        <input className="body-medium" {...props} type={type ?? (show ? 'text' : 'password')} />
        {/* After the input: a <label> forwards clicks to its first labelable descendant,
            and a button placed first would take them. mouseDown is cancelled so toggling
            visibility keeps the caret in the field. */}
        <button
          type="button"
          aria-label={show ? 'Hide Password' : 'Show Password'}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => setShow((s) => !s)}
        >
          {show ? <BiHide size={20} /> : <BiShow size={20} />}
        </button>
      </div>
      {!!error && <p className={s.Error}>{error}</p>}
    </label>
  );
};
